/**
 * anchor name constants
 */

/**
 * All possible anchor tag names
 */
const Hashes = {
    COMMENT_SECTION: 'commentSection',
    RATING_SECTION: 'ratingSection'
};

export {Hashes};
